import styled from 'styled-components';

export const Paragraph = styled.p`
  color: ${({ theme }) => theme.brand.text};
  margin: 0 0 12px;
`;

// The four effects of unlocking, as a list so each reads on its own line.
export const Effects = styled.ul`
  color: ${({ theme }) => theme.brand.text};
  margin: 0 0 20px;
  padding-left: 20px;
  list-style: disc;

  /* GlobalStyles clears list-style on every li */
  li {
    list-style: disc;
    margin-bottom: 8px;
  }
`;

// Cardholder Support link inside the red danger alerts: keeps the alert's red text,
// semibold and underlined so it reads as a link.
export const SupportLink = styled.a`
  color: inherit;
  font-weight: 600;
  text-decoration: underline;

  &:hover,
  &:focus,
  &:visited {
    color: inherit;
    text-decoration: underline;
  }
`;
